import React, { Component } from "react";
import Table from "../components/Table";
import { connect } from "react-redux";
import { UserInfoDialog } from "../dialogs/UserInfoDialog";
import { AreYouSureDialog } from "../dialogs/AreYouSureDialog";
import AddUser from "../containers/AddUser";
import EditUser from "../containers/EditUser";
import { deleteUser } from "../redux/actions/userActions";
import { timeStampToLongString } from "../utils/stringUtils";
import { isCurrentUserSuperAdmin } from "../utils/userRoles";
import { ErrorDialog } from "../dialogs/ErrorDialog";
import { clearErrors } from "../redux/actions/uiActions";
import { USERS, createInfoUrl } from "../utils/routes";

export class usersPage extends Component {
  state = {
    showAddDialog: false,
    showEditDialog: false,
    showAreYouSureDialog: false
  };

  headers = () => {
    let h = [
      { id: 0, title: "Name", sortable: true },
      { id: 1, title: "Email", sortable: true },
      { id: 2, title: "Role", sortable: true },
      { id: 3, title: "Last Login", sortable: true }
    ];

    if (isCurrentUserSuperAdmin())
      h.push({ id: 4, title: "Organization", sortable: true });

    return h;
  };

  extractData = () => {
    const { users, organizations } = this.props;

    let data = [];
    for (let key in users) {
      let { name, email, role, lastLogin, organizationRef } = users[key];
      const lastLoginString = lastLogin
        ? timeStampToLongString(lastLogin)
        : "N/A";

      let row = [name, email, role, lastLoginString];
      let searching = [name, email, role].join(" ");

      if (isCurrentUserSuperAdmin()) {
        const orgName = organizations[organizationRef.id].name;
        row.push(orgName);
        searching += " " + orgName;
      }

      data.push({ key, row, searching });
    }
    return data;
  };

  render() {
    const {
      showAddDialog,
      showEditDialog,
      showAreYouSureDialog
    } = this.state;
    const { 
      users, 
      loading, 
      curentUserUid, 
      deleteUser,
      errorMessage,
      clearErrors
    } = this.props;

    const { history, match } = this.props;
    const { selectedKey } = match.params;

    const currentUser = users[selectedKey];

    return (
      <div>
        {showAddDialog && (
          <AddUser onClose={() => this.setState({ showAddDialog: false })} />
        )}

        {selectedKey && currentUser && !showEditDialog && (
          <UserInfoDialog
            onClose={() => history.push(USERS)}
            onEdit={() => this.setState({ showEditDialog: true })}
            onDelete={() => this.setState({ showAreYouSureDialog: true })}
            user={currentUser}
            loading={loading}
            self={curentUserUid === currentUser.uid}
          />
        )}

        {showAreYouSureDialog && (
          <AreYouSureDialog
            onClose={() => this.setState({ showAreYouSureDialog: false })}
            onDelete={() => {
              this.setState({ showAreYouSureDialog: false });
              history.push(USERS)
              deleteUser({ userKey: selectedKey, uid: currentUser.uid });
            }}
            title={currentUser.name}
          />
        )}

        {showEditDialog && (
          <EditUser
            selectedUserKey={selectedKey}
            onClose={() => this.setState({ showEditDialog: false })}
          />
        )}

        {errorMessage !== "" && (
          <ErrorDialog
            title={"Add/Edit User"}
            message={errorMessage}
            onClose={() => clearErrors()}
          />
        )}

        <Table
          title="Users"
          addNewTitle="New User"
          onAddNewClick={() => this.setState({ showAddDialog: true })}
          headers={this.headers()}
          rows={this.extractData()}
          onRowClick={key => history.push(createInfoUrl(USERS,key))}
          loading={loading}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  users: state.data.users,
  curentUserUid: state.user.user.uid,
  loading: state.ui.loading,
  organizations: state.data.organizations,
  errorMessage: state.ui.errorMessage
});

const mapDispatchToProps = { 
  clearErrors,
  deleteUser 
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(usersPage);
